import _ from "lodash";

export const getDescendingOrderedList = (list) => {
	let orderedList = _.orderBy(list, "createdOnMil", "desc");
	return orderedList;
};
